export const FORM_OWNER_TYPES = {
  PARTY: 'event',
  GROUP: 'group',
};
